import "./AdminWorkspacePanel.css";

import * as m from "../../../../model/model";

import {
  deleteWorkspaceThunk,
  updateWorkspaceThunk,
} from "../../../../store/slices/workspaceThunks";
import { useAppDispatch, useAppSelector } from "../../../../store";

import AdminWorkspaceUsers from "./AdminWorkspaceUsers";
import Buckets from "../../../common/bucket/Buckets";
import ModalBase from "../../../../modals/ModalBase";
import React from "react";
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import { useModal } from "../../../../context/ModalContext";
import { workspaceActions } from "../../../../store/slices/workspaceSlice";

export default function AdminWorkspacePanel() {
  const currentWorkspace = useAppSelector(
    (state) => state.workspace.currentWorkspace
  );

  const { register, handleSubmit, reset } = useForm<m.Workspace>();
  const dispatch = useAppDispatch();
  const { showModal, hideModal } = useModal();

  React.useEffect(() => {
    if (currentWorkspace) {
      reset(currentWorkspace);
    }
  }, [currentWorkspace, reset]);

  const onSubmit = handleSubmit((data) => {
    dispatch(updateWorkspaceThunk(data));
  });

  const onDeleteWorkspaceClick = () => {
    if (!currentWorkspace) return;
    showModal(
      <ModalBase
        header="Delete Workspace"
        body="Are you sure you want to delete this workspace?"
        footer={
          <>
            <button onClick={hideModal}>Cancel</button>
            <button
              onClick={() => {
                dispatch(deleteWorkspaceThunk(currentWorkspace?.id))
                  .unwrap()
                  .then(() => {
                    dispatch(workspaceActions.setCurrentWorkspace(null));
                  });
                hideModal();
              }}
            >
              Delete
            </button>
          </>
        }
      />
    );
  };

  if (!currentWorkspace) return null;

  return (
    <>
      <div className="workspace-panel-header"></div>
      <form className="workspace-panel" onSubmit={onSubmit}>
        <input type="hidden" {...register("id")} value={currentWorkspace.id} />

        <div className="workspace-panel-grid">
          <div className="panel-item panel-label">Name</div>
          <div className="panel-item panel-value">
            <input {...register("name")} />
          </div>

          <div className="panel-item panel-label">Description</div>
          <div className="panel-item panel-value">
            <textarea {...register("description")}></textarea>
          </div>

          <div className="panel-item panel-label">Created</div>
          <div className="panel-item panel-value">
            {currentWorkspace.created}
          </div>

          <div className="panel-item panel-label">Modified</div>
          <div className="panel-item panel-value">
            {currentWorkspace.modified}
          </div>

          <div className="panel-item panel-label">Status</div>
          <div className="panel-item panel-value">
            <select {...register("status")}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="panel-item panel-label">Type</div>
          <div className="panel-item panel-value">
            <select {...register("type")}>
              <option value="course">Course</option>
              <option value="tutoring">Tutoring</option>
              <option value="group">Group</option>
            </select>
          </div>
        </div>

        <div className="panel-item panel-label"></div>
        <div className="panel-item panel-value">
          <div className="workspace-users">
            <AdminWorkspaceUsers />
          </div>
        </div>

        <div className="panel-item panel-label"></div>
        <div className="panel-item panel-value">
          <div className="panel-files">
            <Buckets
              root={`loa/dynamic/workspaces/${currentWorkspace.id}`}
              permissions={["admin"]}
            />
          </div>
        </div>

        {ReactDOM.createPortal(
          <>
            <button className="loa-button" onClick={onDeleteWorkspaceClick}>
              Delete Workspace
            </button>
            <button className="loa-button" onClick={onSubmit}>
              Save
            </button>
          </>,
          document.getElementById("loa-admin-footer") || document.body
        )}
      </form>
    </>
  );
}
